import { QuestionBlock } from '~/models/blocks/question-block.model';
import {
    QuestionType,
    TBlock,
    TOptionableQuestion
} from '~/types/builder.types';
import { BlockLike } from '~/components/Builder/Common/CreationLimitations/creationLimitations.types';

export const reorderOptions =
    (block: QuestionBlock) => (draggedId: string, dropTargetId: string) => {
        const { options } = block.question as TOptionableQuestion;
        const dropTargetIndex = options.findIndex(
            opt => opt.option_id === dropTargetId
        );
        const draggedIndex = options.findIndex(
            opt => opt.option_id === draggedId
        );

        const newOptions = [...options];
        newOptions.splice(draggedIndex, 1);

        newOptions.splice(dropTargetIndex, 0, options[draggedIndex]);
        block.setQuestionOptions(newOptions);
    };

export const getOptionsForDropdownQuestion = (
    options,
    idFieldName = '_id',
    labelFieldName = 'label'
) => {
    return options.map(option => {
        return {
            option_id: option[idFieldName],
            answer_text: option[labelFieldName]
        };
    });
};

export function countUploadQuestionBlocksInBlock(
    block: BlockLike,
    notLoadedFlowChildren?: TBlock[]
): number {
    if (block.type !== 'container_block' || !block.childBlocks) {
        return 0;
    }

    const childBlocks = notLoadedFlowChildren
        ? block.children.map(childBlock =>
              notLoadedFlowChildren.find(
                  _block => _block.block_id === childBlock.block_id
              )
          )
        : block.childBlocks;

    return childBlocks.reduce((count, childBlock) => {
        const blockCount =
            childBlock.isQuestionBlock() &&
            childBlock.question?.question_type === QuestionType.Upload
                ? 1
                : 0;

        return (
            count +
            blockCount +
            countUploadQuestionBlocksInBlock(
                childBlock as BlockLike,
                notLoadedFlowChildren
            )
        );
    }, 0);
}

const questionValidationTypeByType = {
    [QuestionType.Number]: 'number',
    [QuestionType.URL]: 'url'
};

export const getValidationType = (type: QuestionType) => {
    const validation = questionValidationTypeByType[type];

    return {
        validation_type: validation || null
    };
};
